export default __webpack_public_path__ + "static/media/27_2_0.6f08ad04.png";